// extracted by mini-css-extract-plugin
export default {"calendar":"PersonalCalendarPage_calendar__crVaU","view-switch":"PersonalCalendarPage_view-switch__FSEqc"};